// Cache di sessione degli allegati (Blob in memoria + object URL): scaricati in background all'apertura
// della mail, riaperti all'istante ai click successivi. Limite totale in byte con eliminazione dei più vecchi.
import * as api from "./api";

const MAX_BYTES = 250 * 1024 * 1024;
const PREFETCH_MAX = 25 * 1024 * 1024; // oltre questa dimensione non si scarica in anticipo
const cache = new Map(); // key -> { url, blob, ct, size, t }
const inflight = new Map();
let totale = 0;

const IMG = ["jpg", "jpeg", "png", "gif", "webp", "bmp", "avif"];

export const chiave = (id, part, variante = "full") => `${id}#${part}#${variante}`;

export function inCache(id, part, variante = "full") {
  const e = cache.get(chiave(id, part, variante));
  if (e) e.t = Date.now();
  return e || null;
}

function _libera() {
  while (totale > MAX_BYTES && cache.size > 0) {
    let vecchio = null;
    for (const [k, e] of cache) if (!vecchio || e.t < vecchio[1].t) vecchio = [k, e];
    cache.delete(vecchio[0]);
    totale -= vecchio[1].size;
    URL.revokeObjectURL(vecchio[1].url);
  }
}

// Scarica (o attende lo scaricamento già in corso) e mette in cache. Ritorna l'elemento in cache.
export function carica(id, part, variante = "full") {
  const k = chiave(id, part, variante);
  const hit = cache.get(k);
  if (hit) return Promise.resolve(hit);
  if (inflight.has(k)) return inflight.get(k);
  const src = variante === "thumb" ? api.attachmentThumbUrl(id, part) : api.attachmentUrl(id, part);
  const p = fetch(src)
    .then(async (r) => {
      if (!r.ok) {
        let det = "";
        try { det = (await r.json()).detail; } catch (e) { console.debug("allegato: risposta d'errore non JSON", r.status); }
        throw new Error(typeof det === "string" && det ? det : r.status === 504 ? "Il server di posta non risponde (timeout): riprova tra poco" : `Il server ha risposto ${r.status}`);
      }
      const blob = await r.blob();
      const e = { url: URL.createObjectURL(blob), blob, ct: blob.type, size: blob.size, t: Date.now() };
      cache.set(k, e);
      totale += blob.size;
      _libera();
      return e;
    })
    .finally(() => inflight.delete(k));
  inflight.set(k, p);
  return p;
}

// "12 KB" / "2.3 MB" → byte
export function byteDa(dimensione) {
  const m = /([\d.,]+)\s*(B|KB|MB|GB)/i.exec(dimensione || "");
  if (!m) return 0;
  const n = parseFloat(m[1].replace(",", "."));
  return n * { B: 1, KB: 1024, MB: 1024 ** 2, GB: 1024 ** 3 }[m[2].toUpperCase()];
}

// Scarica in anticipo gli allegati di una mail appena viene aperta (immagini: prima la miniatura)
export function prefetchEmail(email) {
  if (!email?.id?.includes("|") || !Array.isArray(email.allegati)) return;
  email.allegati.forEach((a) => {
    if (a.part === undefined) return;
    const img = IMG.includes((a.tipo || "").toLowerCase());
    if (img) carica(email.id, a.part, "thumb").catch(() => {});
    if (byteDa(a.dimensione) <= PREFETCH_MAX && !(img && byteDa(a.dimensione) > 3 * 1024 * 1024)) carica(email.id, a.part, "full").catch(() => {});
  });
}
